import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { getArticleById } from '@/mocks/articles';
import NotFound from '@/pages/NotFound';

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = getArticleById(Number(id));

  if (!article) {
    return <NotFound />;
  }

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    author: { '@type': 'Person', name: article.author },
    datePublished: article.publishDate,
    image: article.coverImage,
    publisher: {
      '@type': 'Organization',
      name: 'bob体育',
      url: 'https://www.bob-sports.com',
    },
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.bob-sports.com/' },
      { '@type': 'ListItem', position: 2, name: '体育资讯', item: 'https://www.bob-sports.com/articles' },
      { '@type': 'ListItem', position: 3, name: article.title },
    ],
  };

  return (
    <>
      <SchemaOrg data={articleSchema} />
      <SchemaOrg data={breadcrumbSchema} />
      <Navbar />

      <Breadcrumb
        items={[
          { label: '体育资讯', href: '/articles' },
          { label: article.title },
        ]}
      />

      <main className="py-8 bg-background-50 min-h-screen">
        <article className="w-full px-4 md:px-6 max-w-4xl mx-auto">
          <div className="mb-6">
            <div className="flex items-center gap-2 mb-3 flex-wrap">
              {article.tags.map((tag) => (
                <span
                  key={tag}
                  className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4 leading-tight">
              {article.title}
            </h1>
            <div className="flex items-center gap-4 text-sm text-foreground-500">
              <span>{article.author}</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span>{article.publishDate}</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span>{article.readTime}阅读</span>
            </div>
          </div>

          <div className="aspect-[16/9] rounded-xl overflow-hidden mb-8">
            <img
              src={article.coverImage}
              alt={article.title}
              className="w-full h-full object-cover"
            />
          </div>

          <div
            className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed
              [&_h2]:text-xl [&_h2]:font-heading [&_h2]:font-bold [&_h2]:text-foreground-950 [&_h2]:mt-8 [&_h2]:mb-4
              [&_p]:mb-4 [&_p]:leading-relaxed
              [&_strong]:text-foreground-900"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />

          <div className="mt-10 pt-8 border-t border-background-200/70">
            <Link
              to="/articles"
              className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors"
            >
              <i className="ri-arrow-left-line"></i> 返回资讯列表
            </Link>
          </div>
        </article>
      </main>

      <Footer />
    </>
  );
}